import { LayerStyling } from "../data";



// @dynamic
export class PaletteUtils {
  static effectiveClasses(styles: LayerStyling,numMonths:number,scale?:number) {
    scale = scale || 1;
    let result = styles?.classes;
    if(!result){
      return undefined;
    }
    result = result.map(c=>c?c*scale:c);
    if(styles.classMultipliers){
      const multiplier = styles.classMultipliers[numMonths-1];
      result = result.map(c=>(c===null)?null:c*multiplier);
    }
    return result;
  }

  static makeAbsAnomalyClasses(styles:LayerStyling,numMonths:number,scale?:number): number[] {
    scale = scale || 1;
    if(styles.anomalyClasses){
      const multiplier = (styles.classMultipliers?styles.classMultipliers[numMonths-1]:1)||1;
      const positiveClasses = styles.anomalyClasses.map(c=>c*multiplier*scale);
      return [
        null,
        ...positiveClasses.map(c=>-c).reverse(),
        ...positiveClasses,
        null
      ];
    }

    let max = styles.anomalyLimit*scale;
    if(!max){
      const baseClasses = PaletteUtils.effectiveClasses(styles,numMonths,scale);
      max = (baseClasses[baseClasses.length-1]||baseClasses[baseClasses.length-2]) * 0.5;
    }
  
    return [
      null,
      // -max,
      -0.75*max,
      -0.50*max,
      -0.25*max,
      -0.1*max,
      -0.05*max,
      0.05*max,
      0.1*max,
      0.25*max,
      0.50*max,
      0.75*max,
      // max,
      null
    ];
  }
}
